"use client";

import React, { useEffect, useState } from "react";
import autofotografieren from "../../../assets/ueber-uns/Auto-fotografieren.webp";
import autoeinfachlosPro from "../../../assets/ueber-uns/Autoeinfachlos-pro-tablet.webp";
import Image from "next/image";

function InfoBoxes() {
  const [scrollOffset, setScrollOffset] = useState(64); // Start at 64px

  useEffect(() => {
    const handleScroll = () => {
      const maxOffset = 64; // Maximum movement in px
      const scrollY = window.scrollY; // Get current scroll position
      const newOffset = Math.max(
        0,
        Math.min(maxOffset, maxOffset - scrollY / 10)
      ); // Adjust as needed
      setScrollOffset(newOffset);
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="InfoBoxes">
      <div className="InfoBox">
        <div className="InfoBox-left">
          <div className="Info-box-left-text-wrapper">
            <h2>Für Autoverkäufer</h2>
            <p>
              Unsere Mission ist es, den Autoverkauf für unsere Kunden so
              einfach, sicher und rentabel wie möglich zu gestalten. Wir bieten
              Autoverkäufern einen schnellen, unkomplizierten Prozess, um ihr
              Fahrzeug in nur wenigen Schritten zu einem hervorragenden Preis zu
              verkaufen.
            </p>
            <p>
              Dank unseres Netzwerks von über 5.000 geprüften Autohändlern, die
              direkt auf Fahrzeuge bieten, können unsere Kunden ihr Auto
              innerhalb von nur 24 Stunden zum besten Preis verkaufen. Unser
              Service ist, als würde der Autoverkäufer alle Autohändler in
              Österreich besuchen, um den Höchstbietenden zu finden – das
              ermöglicht Autoeinfachlos mit nur wenigen Klicks, bequem und
              stressfrei.
            </p>
          </div>
        </div>
        <div className="InfoBox-right">
          <span
            className="Infobox-arrow-background"
            style={{ transform: `translateY(${scrollOffset}px)` }}
          ></span>

          <div className="Infobox-right-img-wrapper">
            <Image
              src={autofotografieren}
              alt="Auto zum verkauf fotografieren"
              className="Infobox-right-img"
            />
          </div>
        </div>
      </div>
      <div className="InfoBox">
        <div className="InfoBox-right secondary">
          <span
            className="Infobox-arrow-background secondary"
            style={{ transform: `translateY(${scrollOffset}px)` }}
          ></span>

          <div className="Infobox-right-img-wrapper secondary">
            <Image
              src={autoeinfachlosPro}
              alt="Auto zum verkauf fotografieren"
              className="Infobox-right-img"
            />
          </div>
        </div>
        <div className="InfoBox-left secondary">
          <div className="Info-box-left-text-wrapper">
            <h2>Warum Autoeinfachlos?</h2>
            <p>
              Mit Autoeinfachlos sparen unsere Kunden wertvolle Zeit und
              Aufwand. Statt mühsamer Preisverhandlungen und langwieriger
              Verkaufsgespräche bieten wir einen schnellen, fairen und
              transparenten Verkaufsprozess, der dir den besten Preis sichert.
            </p>
            <p>
              Deine Daten sind bei uns in sicheren Händen. Wir legen großen Wert
              auf Datenschutz und behandeln alle persönlichen Informationen
              streng vertraulich, damit du dich beim Verkauf vollkommen sicher
              fühlen kannst.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoBoxes;
